import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./Leaderboard.module.scss";

// Adds a way to describe margins, padding, or other context-based styles
interface TopInjectorAdProps extends GptAdProps {
  enableMobile?: boolean;
}

/**
 * An banner ad that runs just below the nav with styling
 * on load.
 *
 * This has poor viewability and is bad for CLS but is important for sales.
 *
 * It will be used sparingly.
 */
const LeaderboardAd = ({
  className,
  enableMobile = false,
  ...props
}: TopInjectorAdProps) => {
  return (
    <GptAd
      className={cx(styles.root, className)}
      format="leaderboard"
      sizesAt0={enableMobile ? "mobile-wide" : ""}
      sizesAt976="leaderboard"
      targetingPos={props.targetingPos || "leaderboard"}
      {...props}
    />
  );
};

export default LeaderboardAd;
